import { mediaQueryTresholds } from '../config';

// SPかどうか
const getIsSmartPhone = (): boolean =>
  mediaQueryTresholds.SP >= window.innerWidth;

export default getIsSmartPhone;
